// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from "stimulus";
import { definitions } from "stimulus:.";
import AccordionController from "stimulus-accordion";

const application = Application.start();
application.load(definitions);
application.register("accordion", AccordionController);
